export enum ExportMethods {
        ForUrl,
        ForView,
        ForFiles,
        ForPrint
}